import styled from 'styled-components';

export const Content = styled.div`
  background: transparent;
  font-size: ${({ theme }) => `${14 + 2 * theme.zoomFonte}px`};
`;
